const MQTT_TTL_MS = 90 * 1000

export const mqttStatusMixin = {
  data() {
    return {
      mqttStatus: 'connected',
      mqttBound: false,
      mqttMessageHandler: null,
      _mqttTTLTimer: null,
      deviceStaleTimers: {},
      legend: [
        {
          name: 'On / Healthy / Okay',
          attr: {
            name: 'square',
            color: '#3CB371',
          },
        },
        {
          name: 'Off / Fault / Not Okay',
          attr: {
            name: 'square',
            color: '#FF5252',
          },
        },
        {
          name: 'No Communication',
          attr: {
            name: 'square',
            color: '#A7A7A7',
          },
        }
      ],
    }
  },
  beforeDestroy() {
    this.unbindMqttEvents()
    if (typeof this.unsubscribeMqtt === 'function') {
      this.unsubscribeMqtt()
    }
  },
  methods: {
    resetMqttState() {
      this.unbindMqttEvents()
      this._clearAllDeviceStaleTimers()
      this.mqttStatus = 'connected'
      this.apiDataLoaded = false
    },
    startMqttStaleTimer() {
      if (this._mqttTTLTimer) clearTimeout(this._mqttTTLTimer)
      this._mqttTTLTimer = setTimeout(() => {
        this.mqttStatus = 'stale'
      }, MQTT_TTL_MS)
    },
    _clearDeviceStaleTimer(deviceId) {
      const timer = this.deviceStaleTimers[deviceId]
      if (timer) {
        clearTimeout(timer)
        this.$delete(this.deviceStaleTimers, deviceId)
      }
    },
    _clearAllDeviceStaleTimers() {
      Object.keys(this.deviceStaleTimers).forEach(deviceId => {
        this._clearDeviceStaleTimer(deviceId)
      })
    },
    _scheduleDeviceStaleTimerMixin(deviceId, onExpire) {
      if (!deviceId) return
      this._clearDeviceStaleTimer(deviceId)
      this.$set(this.deviceStaleTimers, deviceId, setTimeout(() => {
        this._clearDeviceStaleTimer(deviceId)
        if (typeof onExpire === 'function') {
          onExpire(deviceId)
        }
      }, MQTT_TTL_MS))
    },
    _markDeviceLiveMixin(deviceId, onExpire) {
      if (!deviceId) return
      this.$set(this.deviceConnected, deviceId, true)
      this._scheduleDeviceStaleTimerMixin(deviceId, onExpire)
    },
    registerMqttHandlers(messageHandler) {
      if (this.mqttBound) return
      this.mqttMessageHandler = messageHandler
      this._onMqttError = () => {
        this.mqttStatus = 'offline'
      }
      this._onMqttOffline = () => {
        this.mqttStatus = 'offline'
      }
      this._onMqttReconnect = () => {
        this.mqttStatus = 'reconnecting'
      }

      this.$mqtt.on('message', this.mqttMessageHandler)
      this.$mqtt.on('error', this._onMqttError)
      this.$mqtt.on('offline', this._onMqttOffline)
      this.$mqtt.on('reconnect', this._onMqttReconnect)
      this.mqttBound = true
    },
    _removeMqttListener(eventName, handler) {
      if (!handler || !this.$mqtt) return
      if (typeof this.$mqtt.off === 'function') {
        this.$mqtt.off(eventName, handler)
      } else if (typeof this.$mqtt.removeListener === 'function') {
        this.$mqtt.removeListener(eventName, handler)
      }
    },
    unbindMqttEvents() {
      if (!this.mqttBound) return

      this._removeMqttListener('message', this.mqttMessageHandler)
      this._removeMqttListener('error', this._onMqttError)
      this._removeMqttListener('offline', this._onMqttOffline)
      this._removeMqttListener('reconnect', this._onMqttReconnect)

      this.mqttMessageHandler = null
      this._onMqttError = null
      this._onMqttOffline = null
      this._onMqttReconnect = null

      if (this._mqttTTLTimer) {
        clearTimeout(this._mqttTTLTimer)
        this._mqttTTLTimer = null
      }
      this._clearAllDeviceStaleTimers()
      this.mqttStatus = 'connected'
      this.mqttBound = false
    },
  },
}
